module.exports = __webpack_public_path__ + "static/ArchivoNarrow-Regular-160c6c4a0319cfa2ba2eb2fd10bb5b9d.woff";